import type {
  OrganizationMembership,
  OrganizationMembershipResponse,
} from './api';

type tenant_type = 'school';
export interface RequestToCreateOrganizationType {
  name: string;
  organization_type: string;
  tenant_type?: tenant_type;
  website?: string;
  address: string;
  telephone: string;
}

export interface OrganizationProfileRequestType {
  name: string;
  slogan?: string;
  address: string;
  email?: string;
  website?: string;
  about_us?: string;
  telephone: string;
  country: string;
}

export interface OrganizationSkillRequestType {
  skill_type: string;
  name: string;
  description: string;
}

export interface CreateOrganizationComponentProps {
  organizations?: OrganizationMembership;
  onOrganizationFormSubmit: () => void;
}

export interface BoardRequestType {
  name: string;
  description: string;
  head_of_board: string | null;
  parent: number | null;
}

export const ORGANIZATION_TYPES = [
  { id: 1, name: 'High School', value: 'High School', tenant_type: 'school' },
  { id: 2, name: 'IB School', value: 'IB School', tenant_type: 'school' },
  {
    id: 3,
    name: 'Technical Vocational Education and Training (TVET) School',
    value: 'Technical Vocational Education and Training (TVET) School',
    tenant_type: 'school',
  },
  {
    id: 4,
    name: 'Higher Education Institution',
    value: 'Higher Education Institution',
    tenant_type: 'school',
  },
  { id: 5, name: 'NGO/INGO', value: 'NGO/INGO', tenant_type: 'school' },
  {
    id: 6,
    name: 'Company/Business/Enterprise',
    value: 'Company/Business/Enterprise',
    tenant_type: 'school',
  },
  {
    id: 7,
    name: 'City/Municipality',
    value: 'City/Municipality',
    tenant_type: 'school',
  },
  { id: 8, name: 'Other', value: 'Other', tenant_type: 'school' },
];

export interface SelectOrganizationProps {
  data: OrganizationMembershipResponse;
  onClick: (organizationName: string) => void;
  userName?: string;
  onCreateOrganization?: () => void;
  onSignOut?: () => void;
}
